const Profile = () => import('../views/Profile.vue')

export default [
  {
    path: 'entity/user/profile',
    component: Profile,
    meta: { requiresAuth: true },
    name: 'user.profile'
  }
]